<div *ngIf="showBanner" class="cookie-banner">
    {{ 'COOKIE_BANNER.MESSAGE_PART1' | translate }}<br>
    {{ 'COOKIE_BANNER.MESSAGE_PART2' | translate }}
    <button class="accept-btn" (click)="acceptCookies()">
        {{ 'COOKIE_BANNER.ACCEPT_BUTTON' | translate }}
    </button>
    {{ 'COOKIE_BANNER.MESSAGE_PART3' | translate }}
    <a [routerLink]="'/privacyPolicy'" [queryParams]="{ language:this.language}" target="_blank"
        rel="noopener noreferrer">
        {{ 'LANDING_PAGE.PRIVACY_POLICY' | translate }}
    </a>.
</div>